module.exports = __webpack_public_path__ + "static/img/aqzs51.f367ee77.jpg";